{
  "generic.edit": "Bewerken",
  "generic.delete": "Verwijderen",
  "generic.update": "Bijwerken",
  "generic.create": "Aanmaken",
  "generic.cancel": "Annuleren",
  "generic.confirm": "Bevestigen",
  "generic.print": "Afdrukken",
  "generic.close": "Sluiten",
  "generic.save": "Opslaan",
  "generic.save-validation": "Los fouten in het formulier op.",

  "input.select-certificate": "Selecteer een certificaat",
  "input.select-checklist": "Selecteer een checklist",
  "input.select-function": "Selecteer een functie",
  "input.select-organisation": "Selecteer een organisatie",
  "input.select-safety-instruction": "Selecteer een veiligheidsinstructie",

  "context-menu.tab-actions.close": "Sluit tabblad",
  "context-menu.tab-actions.close-all": "Sluit alle tabbladen",
  "context-menu.tab-actions.close-others": "Sluit andere tabbladen",
  "context-menu.tab-actions.split-horizontal": "Split horizontaal",
  "context-menu.tab-actions.split-vertical": "Split verticaal",
  "context-menu.tab-open.open": "Openen",
  "context-menu.tab-open.open-right": "Openen rechts",
  "context-menu.tab-open.open-bottom": "Openen onder",
  "menu.organisations": "Organisaties",
  "menu.people": "Personen",
  "menu.projects": "Projecten",
  "menu.certificates": "Certificaten",
  "menu.safety": "Veiligheids-rapporten",
  "menu.content": "Inhoud",
  "menu.thesaurus": "Functiehuis",
  "auth.login.title": "Inloggen bij het i-LOP platformportaal",
  "auth.login.description": "Gebruik je i-LOP-account om in te loggen op het platformportaal.",
  "auth.login.form.email": "E-mailadres",
  "auth.login.form.email.placeholder": "Voer je e-mailadres in",
  "auth.login.form.password": "Wachtwoord",
  "auth.login.form.password.placeholder": "Voer je wachtwoord in",
  "auth.login.form.submit": "Inloggen",
  "auth.login.form.forgot": "Wachtwoord vergeten?",
  "auth.forgot-password.title": "Wachtwoord vergeten",
  "auth.forgot-password.description": "Geen probleem! Vul hieronder je e-mailadres in en klik op 'Stuur resetlink'. Als je e-mailadres bij ons bekend is, ontvang je een link om je wachtwoord opnieuw in te stellen.",
  "auth.forgot-password.form.email": "E-mailadres",
  "auth.forgot-password.form.email.placeholder": "Voer je e-mailadres in",
  "auth.forgot-password.form.submit": "Stuur resetlink",
  "auth.forgot-password.form.back-to-login": "Terug naar inloggen",
  "auth.forgot-password.form.success.sent-to": "We hebben een bevestigingslink gestuurd naar",
  "auth.forgot-password.form.success.check-email": "Controleer je e-mail om je wachtwoord opnieuw in te stellen.",
  "auth.reset-password.title": "Wachtwoord opnieuw instellen",
  "auth.reset-password.description": "Je hebt gekozen om je wachtwoord opnieuw in te stellen. Gebruik het formulier hieronder om je nieuwe wachtwoord in te voeren. Zodra je het hebt bijgewerkt, moet je opnieuw inloggen.",
  "auth.reset-password.form.password": "Nieuw wachtwoord",
  "auth.reset-password.form.password.placeholder": "Voer je nieuwe wachtwoord in",
  "auth.reset-password.form.password-confirm": "Bevestig nieuw wachtwoord",
  "auth.reset-password.form.password-confirm.placeholder": "Voer je nieuwe wachtwoord opnieuw in",
  "auth.reset-password.form.submit": "Wachtwoord wijzigen",
  "auth.reset-password.form.success": "Je wachtwoord is succesvol gewijzigd. Je kunt nu inloggen met je nieuwe wachtwoord.",
  "auth.reset-password.form.back-to-login": "Terug naar inloggen",
  "auth.reset-password.form.password-mismatch": "De wachtwoorden komen niet overeen. Controleer je invoer en probeer het opnieuw.",
  "auth.accept-invitation.title": "Account aanmaken",
  "auth.accept-invitation.description": "Een beheerder heeft je uitgenodigd om en account op het i-LOP platform aan te maken middels {{email}}. Je gegevens zijn al ingevuld - het enige dat jij hoeft te doen, is een wachtwoord kiezen.",
  "auth.accept-invitation.form.password": "Wachtwoord",
  "auth.accept-invitation.form.password.placeholder": "Voer je wachtwoord in",
  "auth.accept-invitation.form.password-confirm": "Bevestig wachtwoord",
  "auth.accept-invitation.form.password-confirm.placeholder": "Voer je wachtwoord opnieuw in",
  "auth.accept-invitation.form.submit": "Account aanmaken",
  "auth.accept-invitation.form.password-mismatch": "De wachtwoorden komen niet overeen. Controleer je invoer en probeer het opnieuw.",
  "auth.accept-invitation.invalid-token.title": "Ongeldige link",
  "auth.accept-invitation.invalid-token.description": "De link die je hebt gebruikt is niet meer geldig. Mogelijk is er al een account aangemaakt of is de link verlopen.",
  "table.per-page": "Items per pagina:",
  "table.empty.title": "Geen gegevens gevonden",
  "table.empty.sub-title": "Er zijn geen resultaten voor je huidige selectie. Probeer om je filters aan te passen of maak een nieuw item aan.",
  "table.toast.error": "Er is een fout opgetreden bij het ophalen van de gegevens",
  "organisations.table.logo": "Logo",
  "organisations.table.organisation-name": "Organisatienaam",
  "organisations.table.business-registry-number": "“KvK-nummer”",
  "organisations.table.city": "Plaatsnaam",
  "organisations.table.street-name": "Straat",
  "organisations.table.website": "Website",
  "organisations.new": "Nieuwe organisatie",
  "organisations.title": "Lijst van organisaties",
  "organisation-edit.edit-title": "Organisatie bewerken",
  "organisation-edit.new-title": "Nieuwe organisatie",
  "organisation-edit.delete-button": "Verwijder organisatie",
  "organisation-edit.delete-title": "Organisatie verwijderen",
  "organisation-edit.delete-confirm": "Verwijderen",
  "organisation-edit.delete-message": "Weet je zeker dat je deze organisatie wilt verwijderen?",
  "organisation-edit.delete-success": "Organisatie succesvol verwijderd.",
  "organisation-edit.delete-error": "Er is een fout opgetreden bij het verwijderen van de organisatie.",
  "organisation-edit.manage-role-assignments": "Rolverdeling beheren",
  "organisation-edit.manage-safety-requirements": "Veiligheidseisen beheren",
  "organisation-form.general-data": "Algemene gegevens",
  "organisation-form.visitor-address": "Bezoekadres",
  "organisation-form.postal-address": "Postadres",
  "organisation-form.active": "Actief",
  "organisation-form.logo": "Logo",
  "organisation-form.click-to-upload-logo": "Klik om logo te uploaden",
  "organisation-form.remove-logo": "Verwijder logo",
  "organisation-form.coc-number": "KvK-nummer",
  "organisation-form.organisation-name": "Organisatienaam",
  "organisation-form.description": "Omschrijving",
  "organisation-form.parent-organisation": "Moederorganisatie",
  "organisation-form.email-address": "E-mailadres",
  "organisation-form.website": "Website",
  "organisation-form.phone-number": "Telefoonnummer",
  "organisation-form.oin-number": "OIN-nummer",
  "organisation-form.city": "Plaats",
  "organisation-form.street": "Straat",
  "organisation-form.house-number": "Huisnummer",
  "organisation-form.zip-code": "Postcode",
  "organisation-form.save-success": "Organisatie succesvol opgeslagen.",
  "organisation-form.save-error": "Er is een fout opgetreden bij het opslaan van de organisatie.",
  "organisation-form.save-validation": "Los eerst de fouten in het formulier op.",
  "PlatformAdmin": "Platformbeheerder",
  "app-role.View": "Leesrechten",
  "app-role.Admin": "Beheerder",
  "app-role.SafetyCoordinator": "Veiligheidscoordinator",
  "toast.error": "Foutmelding",
  "toast.success": "Gelukt",
  "toast.warning": "Waarschuwing",
  "toast.info": "Informatie",
  "password-complexity.requirements": "Wachtwoorden moeten ten minste voldoen aan:",
  "password-complexity.min-length": "Minimaal {{minLength}} karakters",
  "password-complexity.uppercase": "Minimaal één hoofdletter",
  "password-complexity.lowercase": "Minimaal één kleine letter",
  "password-complexity.digit": "Minimaal één cijfer",
  "password-complexity.special-char": "Minimaal één speciaal teken",
  "errors.authentication.invalid": "Je e-mailadres of wachtwoord klopt niet",
  "errors.authentication.try_later": "Het is momenteel niet mogelijk om in te loggen. Probeer het later opnieuw.",
  "errors.authentication.generic": "Er is een fout opgetreden bij het inloggen. Probeer het opnieuw.",
  "errors.reset.generic": "Mogelijk is dit token om je wachtwoord opnieuw in te stellen al gebruikt of is het verlopen. Probeer het opnieuw.",
  "errors.invitation.generic": "Mogelijk is dit token om je account aan te maken al gebruikt of is het verlopen. Probeer het opnieuw.",
  "auth.invalid-role.title": "Geen toegang",
  "auth.invalid-role.description": "Je hebt met dit account geen toegang tot deze applicatie. Neem contact op met je systeembeheerder voor meer informatie.",
  "auth.invalid-role.back-to-login": "Terug naar inloggen",
  "context-menu.account.logout": "Uitloggen",
  "errors.generic": "Er is een fout opgetreden. Probeer het opnieuw.",
  "errors.person.email-duplicate": "Er bestaat al een persoon met dit e-mailadres.",
  "organisation-edit.admins": "Beheerders",
  "invite-or-add-person-modal.title": "Persoon uitnodigen of toevoegen",
  "invite-or-add-person-modal.description": "Gebruik deze modal om een nieuwe persoon uit te nodigen of een bestaande persoon aan de organisatie toe te voegen. Vul eerst het e-mailadres in van de persoon die je wilt toevoegen. Als deze nog niet geregistreerd is, moet je de gegevens invullen.",
  "invite-or-add-person-modal.step2.description": "Deze persoon bestaat nog niet. Vul hieronder de gegevens in.",
  "invite-or-add-person-modal.step3.description": "Selecteer nu de rol van de persoon die je wilt toevoegen.",
  "invite-or-add-person-modal.form.email": "E-mailadres",
  "invite-or-add-person-modal.form.email.placeholder": "Voer het e-mailadres in van de persoon die je wilt toevoegen",
  "invite-or-add-person-modal.form.first-name": "Voornaam",
  "invite-or-add-person-modal.form.first-name.placeholder": "Voer voornaam in",
  "invite-or-add-person-modal.form.last-name": "Achternaam",
  "invite-or-add-person-modal.form.last-name.placeholder": "Voer achternaam in",
  "invite-or-add-person-modal.form.function": "Functie",
  "invite-or-add-person-modal.form.function.placeholder": "Voer functie in",
  "invite-or-add-person-modal.form.role": "Rol",
  "invite-or-add-person-modal.form.role.placeholder": "Selecteer rol",
  "invite-or-add-person-modal.form.send-invitation": "Stuur uitnodiging onmiddellijk",
  "invite-or-add-person-modal.next": "Volgende",
  "invite-or-add-person-modal.cancel": "Annuleren",
  "invite-or-add-person-modal.back": "Terug",
  "invite-or-add-person-modal.create": "Toevoegen",
  "edit-person-role-modal.title": "Rol van persoon bewerken",
  "edit-person-role-modal.description": "Gebruik deze modal om de rol van de persoon binnen de organisatie te bewerken.",
  "edit-person-role-modal.form.role": "Rol",
  "edit-person-role-modal.form.role.placeholder": "Selecteer rol",
  "edit-person-role-modal.save": "Opslaan",
  "edit-person-role-modal.cancel": "Annuleren",
  "context-menu.person-reference.remove": "Persoon verwijderen",
  "context-menu.person-reference.change-role": "Rol wijzigen",
  "projects.table.logo": "Logo",
  "projects.table.project-name": "Projectnaam",
  "projects.table.project-code": "Projectcode",
  "projects.table.client": "Opdrachtgever",
  "projects.table.contractor": "Opdrachtnemer",
  "projects.table.owner": "Projectbeheerder",
  "projects.table.city": "Stad",
  "projects.table.street-name": "Straat",
  "projects.new": "Nieuw project",
  "projects.title": "Lijst van projecten",
  "project-edit.title-edit": "Project bewerken",
  "project-edit.title-new": "Nieuw project",
  "project-edit.delete": "Project verwijderen",
  "project-edit.close": "Sluiten",
  "project-edit.manage-role-assignments": "Roltoewijzingen beheren",
  "project-edit.manage-safety-requirements": "Veiligheidseisen beheren",
  "project-edit.delete-button": "Project verwijderen",
  "project-edit.delete-title": "Project verwijderen",
  "project-edit.delete-message": "Weet je zeker dat je dit project wilt verwijderen?",
  "project-edit.delete-confirm": "Verwijderen",
  "project-edit.delete-success": "Project succesvol verwijderd.",
  "project-edit.delete-error": "Er is een fout opgetreden bij het verwijderen van het project.",
  "project-edit.qr-code-button": "QR-code",
  "project-edit.qr-code-modal-title": "Project QR-code",
  "project-edit.qr-code-modal-alt": "Project QR-code afbeelding",
  "project-form.general-data": "Algemene gegevens",
  "project-form.address": "Adres",
  "project-form.title": "Titel",
  "project-form.logo": "Logo",
  "project-form.click-to-upload-logo": "Klik om logo te uploaden",
  "project-form.remove-logo": "Verwijder logo",
  "project-form.active": "Actief",
  "project-form.description": "Omschrijving",
  "project-form.project-code": "Projectcode",
  "project-form.client": "Opdrachtgever",
  "project-form.contractor": "Opdrachtnemer",
  "project-form.owner": "Projectbeheerder",
  "project-form.chief-safety-officer": "Hoofd veiligheidsfunctionaris:",
  "project-form.start-date": "Startdatum",
  "project-form.end-date": "Einddatum",
  "project-form.city": "Stad",
  "project-form.street": "Straat",
  "project-form.house-number": "Huisnummer",
  "project-form.zip-code": "Postcode",
  "project-form.organisation-none": "Geen",
  "project-form.admins": "Projectbeheerders",
  "project-form.responsibilities": "Verantwoordelijkheden",
  "project-form.safety-contact": "Veiligheidsaanspreekpunt",
  "project-form.safety-contact.select": "Selecteer Veiligheidsaanspreekpunt",
  "project-form.safety-director": "Regievoerder Veiligheid",
  "project-form.safety-director.select": "Selecteer Regievoerder Veiligheid",
  "project-form.project-risks": "Projectrisico's",
  "project-form.collision-hazard": "Aanrijdgevaar",
  "project-form.falling-from-height": "Vallen van hoogte",
  "project-form.electrocution": "Elektrocutie",
  "project-form.hoisting-and-transport": "Hijsen en transport van bouwdelen",
  "project-form.hazardous-substances": "Gevaarlijke stoffen",
  "project-form.save-success": "Project succesvol opgeslagen.",
  "project-form.save-error": "Er is een fout opgetreden bij het opslaan van het project.",
  "project-form.save-validation": "Los eerst de fouten in het formulier op.",
  "project-form.load-error": "Fout bij het laden van het project.",
  "project-form.load-client-error": "Er is een fout opgetreden bij het laden van de organisatie.",
  "certificates.title": "Lijst van Certificaten",
  "certificates.new": "Nieuw Certificaat",
  "certificates.logo": "Logo",
  "certificates.name": "Naam",
  "certificates.description": "Beschrijving",
  "certificates.issuingOrganisations": "Uitgevende Organisaties",
  "certificates.gracePeriod": "Uitstelperiode",
  "certificates.days": "dagen",
  "certificates.newTitle": "Nieuw Certificaat",
  "certificates.editTitle": "Certificaat Bewerken",
  "certificates.loadError": "Fout bij het laden van certificaat",
  "certificates.loadOrganisationsError": "Fout bij het laden van organisaties",
  "certificates.loadRegistriesError": "Fout bij het laden van certificaatregisters",
  "certificates.createSuccess": "Certificaat succesvol aangemaakt",
  "certificates.createError": "Fout bij het aanmaken van certificaat",
  "certificates.updateSuccess": "Certificaat succesvol bijgewerkt",
  "certificates.updateError": "Fout bij het bijwerken van certificaat",
  "certificates.deleteSuccess": "Certificaat succesvol verwijderd",
  "certificates.deleteError": "Fout bij het verwijderen van certificaat",
  "certificates.logoRequired": "Logo is verplicht voor nieuwe certificaten",
  "certificates.fileError": "Fout bij het verwerken van bestand",
  "certificates.error.registryConflict": "Deze Registerbron is al toegewezen aan een ander certificaat",
  "certificates.invalidFileType": "Selecteer een geldig afbeeldingsbestand",
  "certificates.fileTooLarge": "Bestandsgrootte moet kleiner zijn dan 5MB",
  "certificates.confirmDelete.title": "Certificaat Verwijderen",
  "certificates.confirmDelete.message": "Weet je zeker dat je dit certificaat wilt verwijderen?",
  "certificates.form.name": "Certificaatnaam",
  "certificates.form.namePlaceholder": "Voer certificaatnaam in",
  "certificates.form.description": "Beschrijving",
  "certificates.form.descriptionPlaceholder": "Voer certificaatbeschrijving in",
  "certificates.form.logo": "Logo",
  "certificates.form.logoPlaceholder": "Kies certificaatlogo",
  "certificates.form.logoBackgroundColor": "Logo Achtergrondkleur",
  "certificates.form.logoBackgroundColorPlaceholder": "Voer achtergrondkleur in (bijv. #ffffff)",
  "certificates.form.issuingOrganisation": "Uitgevende Organisatie",
  "certificates.form.issuingOrganisationPlaceholder": "Selecteer uitgevende organisatie",
  "certificates.form.issuingOrganisations": "Uitgevende Organisaties",
  "certificates.form.issuingOrganisationsPlaceholder": "Selecteer uitgevende organisaties",
  "certificates.form.gracePeriod": "Uitstelperiode (Dagen)",
  "certificates.form.gracePeriodPlaceholder": "Voer uitstelperiode in dagen in",
  "certificates.form.registrySource": "Registerbron",
  "certificates.form.registrySourcePlaceholder": "Selecteer registerbron (optioneel)",
  "certificates.form.validityYears": "Geldigheidsduur (Jaren, optioneel)",
  "certificates.form.validityYearsPlaceholder": "Voer geldigheidsduur in",
  "common.edit": "Bewerken",
  "common.delete": "Verwijderen",
  "common.actions": "Acties",
  "common.create": "Aanmaken",
  "common.update": "Bijwerken",
  "common.global": "Globaal",
  "project-form.end-date-before-start-date": "De einddatum kan niet voor de startdatum liggen.",
  "persons.table.avatar": "Profielfoto",
  "persons.table.first-name": "Voornaam",
  "persons.table.last-name": "Achternaam",
  "persons.table.email": "E-mailadres",
  "persons.table.organisation": "Organisatie",
  "persons.table.last-login": "Laatste login",
  "persons.table.never-logged-in": "Nooit ingelogd",
  "persons.table.actions": "Actions",
  "persons.table.actions.invite": "Stuur uitnodiging",
  "persons.table.actions.reinvite": "Stuur uitnodiging opnieuw",
  "persons.table.invitation-status": "Uitnodigingsstatus",
  "persons.new": "Nieuwe Persoon",
  "persons.title": "Lijst van Personen",
  "persons.already-has-account": "Deze persoon heeft al een account",
  "persons.invitation-sent": "Uitnodiging succesvol verzonden",
  "persons.invitation-status.accepted": "Geaccepteerd",
  "persons.invitation-status.expired": "Verlopen",
  "persons.invitation-status.invited": "Uitgenodigd",
  "persons.invitation-status.not-invited": "Niet uitgenodigd",
  "person-edit.title-edit": "Persoon Bewerken",
  "person-edit.title-new": "Nieuwe Persoon",
  "person-edit.delete": "Persoon Verwijderen",
  "person-edit.close": "Sluiten",
  "person-edit.delete-button": "Persoon Verwijderen",
  "person-edit.delete-title": "Persoon Verwijderen",
  "person-edit.delete-message": "Weet je zeker dat je deze persoon wilt verwijderen?",
  "person-edit.delete-confirm": "Verwijderen",
  "person-edit.delete-success": "Persoon succesvol verwijderd.",
  "person-edit.delete-error": "Er is een fout opgetreden bij het verwijderen van de persoon.",
  "person-edit.already-has-account": "Deze persoon heeft al een account",
  "person-edit.invitation-sent": "Uitnodiging succesvol verzonden",
  "person-edit.invite-button": "Stuur uitnodiging",
  "person-edit.reinvite-button": "Stuur uitnodiging opnieuw",
  "person-form.avatar": "Profielfoto",
  "person-form.avatar.remove": "Verwijder foto",
  "person-form.general-data": "Algemene Gegevens",
  "person-form.first-name": "Voornaam",
  "person-form.first-name.placeholder": "Voer voornaam in",
  "person-form.last-name": "Achternaam",
  "person-form.last-name.placeholder": "Voer achternaam in",
  "person-form.email": "E-mailadres",
  "person-form.email.placeholder": "Voer e-mailadres in",
  "person-form.active": "Actief",
  "person-form.gender": "Geslacht",
  "person-form.gender.male": "Man",
  "person-form.gender.female": "Vrouw",
  "person-form.gender.other": "Anders",
  "person-form.date-of-birth": "Geboortedatum",
  "person-form.date-of-birth.placeholder": "Voer geboortedatum in",
  "person-form.function": "Functie",
  "person-form.function.placeholder": "Voer functie in",
  "person-form.organisation": "Organisatie",
  "person-form.organisation.placeholder": "Selecteer organisatie",
  "person-form.role": "Rol",
  "person-form.role.placeholder": "Selecteer rol",
  "person-form.employments": "Dienstverbanden",
  "person-form.save-success": "Persoon succesvol opgeslagen.",
  "person-form.save-error": "Er is een fout opgetreden bij het opslaan van de persoon.",
  "person-form.save-validation": "Los eerst de fouten in het formulier op.",
  "employment.create-title": "Nieuw dienstverband toevoegen",
  "employment.edit-title": "Dienstverband bewerken",
  "employment.organisation": "Organisatie",
  "employment.organisation-placeholder": "Selecteer organisatie",
  "employment.function": "Functie",
  "employment.function-placeholder": "Selecteer functie",
  "employment.start-date": "Startdatum",
  "employment.end-date": "Einddatum (optioneel)",
  "employment.managerial": "Leidinggevend",
  "employment.managerial-label": "Werknemer had een leidinggevende rol",
  "employment.active": "Actief",
  "employment.inactive": "Inactief",
  "employment.create-success": "Dienstverband succesvol aangemaakt.",
  "employment.create-error": "Er is een fout opgetreden bij het aanmaken van het dienstverband.",
  "employment.update-success": "Dienstverband succesvol bijgewerkt.",
  "employment.update-error": "Er is een fout opgetreden bij het bijwerken van het dienstverband.",
  "employment.delete-success": "Dienstverband succesvol verwijderd.",
  "employment.delete-error": "Er is een fout opgetreden bij het verwijderen van het dienstverband.",
  "employment.delete-confirm-title": "Dienstverband verwijderen",
  "employment.delete-confirm-message": "Weet je zeker dat je dit dienstverband wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
  "employment.person-not-saved-error": "Sla eerst de persoon op voordat u dienstverbanden toevoegt.",
  "employment.timeline.no-employments": "Geen dienstverband geschiedenis beschikbaar.",
  "employment.timeline.add-employment": "Dienstverband toevoegen",
  "employment.timeline.present": "Huidig",
  "create-or-edit-person-certificate-modal.title": "Certificaat beheren",
  "create-or-edit-person-certificate-modal.description": "Gebruik deze modal om een certificaat voor de persoon aan te maken of te bewerken.",
  "create-or-edit-person-certificate-modal.form.certificate": "Certificaat",
  "create-or-edit-person-certificate-modal.form.issued-on": "Uitgegeven op",
  "create-or-edit-person-certificate-modal.form.issued-on.placeholder": "Selecteer datum",
  "create-or-edit-person-certificate-modal.form.expires-on": "Geldig tot",
  "create-or-edit-person-certificate-modal.form.expires-on.placeholder": "Selecteer datum",
  "create-or-edit-person-certificate-modal.form.save": "Opslaan",
  "create-or-edit-person-certificate-modal.form.cancel": "Annuleren",
  "person-form.issued-on": "Uitgegeven op",
  "context-menu.generic-update-delete.edit": "Bewerken",
  "context-menu.generic-update-delete.delete": "Verwijderen",
  "person-edit.certificates": "Certificaten",

  "select-person-modal.title": "Persoon selecteren",
  "select-person-modal.description": "Gebruik deze modal om een persoon voor het project te selecteren. Vul eerst het e-mailadres van de persoon in. Als deze nog niet geregistreerd is, moet je de gegevens invullen.",
  "select-person-modal.step2.description": "Deze persoon bestaat nog niet. Vul hieronder de gegevens in.",
  "select-person-modal.form.email": "E-mailadres",
  "select-person-modal.form.email.placeholder": "Voer het e-mailadres in van de persoon",
  "select-person-modal.form.first-name": "Voornaam",
  "select-person-modal.form.first-name.placeholder": "Voer voornaam in",
  "select-person-modal.form.last-name": "Achternaam",
  "select-person-modal.form.last-name.placeholder": "Voer achternaam in",
  "select-person-modal.form.function": "Functie",
  "select-person-modal.form.function.placeholder": "Voer functie in",
  "select-person-modal.next": "Volgende",
  "select-person-modal.cancel": "Annuleren",
  "select-person-modal.back": "Terug",
  "select-person-modal.select": "Selecteren",

  "role-assignments.title": "Rolverdelingen",
  "role-assignments.search-placeholder": "Zoek personen of organisaties...",
  "role-assignments.role-placeholder": "Selecteer een rol...",
  "role-assignments.add-assignment": "Rolverdeling toevoegen",
  "role-assignments.avatar-alt": "Avatar of logo",
  "role-assignments.send-invite-to": "Uitnodiging versturen naar:",
  "role-assignments.edit-title": "Rolverdeling bewerken",
  "role-assignments.principal-label": "Betrokkene",
  "role-assignments.role-label": "Rol",
  "role-assignments.save": "Opslaan",
  "role-assignments.saving": "Bezig met opslaan...",
  "role-assignments.role-required": "Rol is verplicht.",
  "role-assignments.update-success": "Rol succesvol bijgewerkt",
  "role-assignments.update-error": "Bijwerken van rol mislukt",
  "role-assignments.add-error": "Toevoegen van rolverdeling mislukt.",
  "role-assignments.delete-error": "Verwijderen van rolverdeling mislukt.",
  "role-assignments.add-validation": "Selecteer een persoon/organisatie en een rol.",
  "role-assignments.name": "Naam",
  "role-assignments.email": "E-mail",
  "role-assignments.type": "Type",
  "role-assignments.role": "Rol",
  "role-assignments.delete-title": "Rolverdeling verwijderen",
  "role-assignments.delete-message": "Weet je zeker dat je deze roldeling wilt verwijderen?",
  "safety-reports.title-all": "Alle veiligheidsrapporten",
  "safety-reports.category.Accident": "Ongeval",
  "safety-reports.category.UnsafeSituation": "Onveilige situatie",
  "safety-reports.category.SafeSituation": "Veilige situatie",
  "safety-reports.status.New": "Nieuw",
  "safety-reports.status.InProgress": "In behandeling",
  "safety-reports.status.Solved": "Opgelost",
  "safety-reports.status.OnHold": "Gepauzeerd",
  "safety-reports.table.status": "Status",
  "safety-reports.table.reporter": "Melder",
  "safety-reports.table.project": "Project",
  "safety-reports.table.assigned-to": "Toegewezen aan",
  "safety-reports.table.description": "Beschrijving",
  "safety-reports.table.category": "Categorie",
  "safety-reports.table.date-created": "Datum aangemaakt",
  "safety-reports.unassigned": "Niet toegewezen",
  "safety-report-detail.error.title": "Laden van veiligheidsrapport mislukt",
  "safety-report-detail.title": "Veiligheidsrapport #{{id}}",
  "safety-report-detail.urgent": "Urgent",
  "safety-report-detail.normal": "Normaal",
  "safety-report-detail.anonymous": "Anoniem",
  "safety-report-detail.sections.details": "Details",
  "safety-report-detail.sections.status": "Status",
  "safety-report-detail.sections.logs": "Logboek",
  "safety-report-detail.sections.comments": "Opmerkingen",
  "safety-report-detail.fields.project": "Project",
  "safety-report-detail.fields.reporter": "Melder",
  "safety-report-detail.fields.category": "Categorie",
  "safety-report-detail.fields.urgency": "Urgentie",
  "safety-report-detail.fields.created-at": "Aangemaakt op",
  "safety-report-detail.fields.solved-at": "Opgelost op",
  "safety-report-detail.fields.description": "Beschrijving",
  "safety-report-detail.fields.risk": "Risico",
  "safety-report-detail.fields.photos": "Foto's",
  "safety-report-detail.fields.current-status": "Huidige status",
  "safety-report-detail.fields.assigned-to": "Toegewezen aan",
  "safety-report-detail.unassigned": "Niet toegewezen",
  "safety-report-detail.status-editing-note": "Status en toewijzing kunnen alleen worden gewijzigd door gebruikers met de juiste rechten.",
  "safety-report-detail.no-logs": "Geen logboek beschikbaar.",
  "safety-report-detail.log.created": "Melding aangemaakt door {{actorName}}",
  "safety-report-detail.log.status-changed": "Status gewijzigd door {{actorName}} naar {{newStatus}}",
  "safety-report-detail.log.commented": "Opmerking toegevoegd door {{actorName}}",
  "safety-report-detail.log.assigned": "Toegewezen aan {{assignedToPersonName}} door {{actorName}}",
  "safety-report-detail.log.unassigned": "Niet meer toegewezen aan persoon door {{actorName}}",
  "safety-report-detail.log.unknown": "Onbekende logregel",
  "safety-report-detail.save-success": "Veiligheidsrapport succesvol bijgewerkt.",
  "safety-report-detail.save-error": "Bijwerken van veiligheidsrapport mislukt.",
  "safety-report-detail.validation-error": "Los eerst de fouten in het formulier op.",

  "safety-reports.create-new": "Nieuw Veiligheidsrapport",
  "safety-report-create.title": "Veiligheidsrapport Aanmaken",
  "safety-report-form.general-information": "Algemene Informatie",
  "safety-report-form.details": "Details",
  "safety-report-form.category": "Categorie",
  "safety-report-form.project": "Project",
  "safety-report-form.risk-category": "Risicocategorie",
  "safety-report-form.risk": "Risico",
  "safety-report-form.description": "Beschrijving",
  "safety-report-form.photos": "Foto's",
  "safety-report-form.click-to-upload-photos": "Klik om foto's te uploaden",
  "safety-report-form.selected-photos": "Geselecteerde Foto's",
  "safety-report-form.urgent": "Urgent",
  "safety-report-form.solved": "Opgelost",
  "safety-report-form.create-success": "Veiligheidsrapport succesvol aangemaakt.",
  "safety-report-form.create-error": "Er is een fout opgetreden bij het aanmaken van het veiligheidsrapport.",
  "safety-report-form.validation-error": "Los eerst de fouten in het formulier op.",
  "safety-report-form.description-or-photos-required": "Beschrijving of foto's zijn verplicht.",
  "safety-report-form.invalid-file-type": "Ongeldig bestandstype. Selecteer een afbeeldingsbestand.",
  "safety-report-form.file-too-large": "Bestandsgrootte te groot. Maximale grootte is 5MB.",

  "safety-report.fields.actions-taken": "Acties Onderzocht",
  "safety-report.fields.victims": "Slachtoffers",
  "safety-report.fields.absenteeism": "Verzuim",
  "safety-report.fields.hospitalised": "Ziekenhuisopname",

  "safety-report-detail.add-comment": "Opmerking toevoegen",
  "safety-instructions.title": "Veiligheidsinstructies",
  "safety-instructions.create": "Nieuwe veiligheidsinstructie",
  "safety-instructions.table.title": "Titel",
  "safety-instructions.table.type": "Type",
  "safety-instructions.table.organisation": "Organisatie",
  "safety-instructions.table.status": "Status",
  "safety-instructions.edit.title": "Veiligheidsinstructie bewerken",
  "safety-instructions.new.title": "Nieuwe veiligheidsinstructie",
  "safety-instructions.delete-button": "Veiligheidsinstructie verwijderen",
  "safety-instructions.delete-title": "Veiligheidsinstructie verwijderen",
  "safety-instructions.delete-message": "Weet je zeker dat je deze veiligheidsinstructie wilt verwijderen?",
  "safety-instructions.delete-confirm": "Verwijderen",

  "safety-instructions.create-modal.header": "Veiligheidsinstructie aanmaken",
  "safety-instructions.create-modal.title": "Titel",
  "safety-instructions.create-modal.title.required": "Titel is verplicht",
  "safety-instructions.create-modal.type": "Type",
  "safety-instructions.create-modal.type.generic": "Algemeen",
  "safety-instructions.create-modal.type.video": "Video",
  "safety-instructions.create-modal.type.required": "Type is verplicht",
  "safety-instructions.create-modal.organisation": "Organisatie",
  "safety-instructions.create-modal.organisation.required": "Organisatie is verplicht",
  "safety-instructions.create-modal.cancel": "Annuleren",
  "safety-instructions.create-modal.create": "Aanmaken",

  "safety-instruction-form.details": "Details",
  "safety-instruction-form.name": "Naam",
  "safety-instruction-form.type": "Type",
  "safety-instruction-form.type.Generic": "Algemeen",
  "safety-instruction-form.type.Video": "Video",
  "safety-instruction-form.created-by": "Aangemaakt door",
  "safety-instruction-form.organisation": "Organisatie",
  "safety-instruction-form.click-to-upload-thumbnail": "Klik om miniatuur te uploaden",
  "safety-instruction-form.thumbnail": "Miniatuur",
  "safety-instruction-form.remove-thumbnail": "Verwijder miniatuur",
  "safety-instruction-form.status": "Status",
  "safety-instruction-form.status-draft": "Concept",
  "safety-instruction-form.status-published": "Gepubliceerd",
  "safety-instruction-form.video": "Video",
  "safety-instruction-form.save-validation": "Los eerst de fouten in het formulier op.",
  "safety-instruction-form.save-error": "Er is een fout opgetreden bij het opslaan van de veiligheidsinstructie.",
  "safety-instruction-form.save-success": "Veiligheidsinstructie succesvol opgeslagen.",
  "safety-instruction-form.blocks": "Blokken",
  "safety-instruction-form.blocks.text": "Tekst",
  "safety-instruction-form.blocks.text-placeholder": "Voer hier tekst in",
  "safety-instruction-form.blocks.image": "Afbeelding",
  "safety-instruction-form.blocks.image.drop-image": "Sleep afbeelding hierheen",
  "safety-instruction-form.blocks.image.or-click-to-select": "of klik om te selecteren",
  "safety-instruction-form.blocks.video": "Video",
  "safety-instruction-form.blocks.video.video-url": "Video URL",
  "safety-instruction-form.blocks.video.preview": "Videovoorbeeld",
  "safety-instruction-form.blocks.video.unsupported": "Alleen video's van https://youtube.com en https://vimeo.com worden ondersteund",
  "safety-instruction-form.blocks.multiple-choice-question": "Meerkeuzevraag",
  "safety-instruction-form.blocks.mcq.question": "Vraag",
  "safety-instruction-form.blocks.mcq.question-placeholder": "Voer hier uw vraag in",
  "safety-instruction-form.blocks.mcq.answers": "Antwoorden",
  "safety-instruction-form.blocks.mcq.answer-placeholder": "Voer antwoord in",
  "safety-instruction-form.blocks.mcq.correct": "Correct",
  "safety-instruction-form.blocks.mcq.add-answer": "Antwoord Toevoegen",
  "safety-instruction-form.blocks.mcq.all-correct-answers-required": "Alle juiste antwoorden moeten worden geselecteerd",
  "safety-instruction-form.blocks.mcq.question-required": "Vraag is verplicht",
  "safety-instruction-form.blocks.mcq.answer-required": "Antwoord is verplicht",
  "safety-instruction-form.blocks.mcq.correct-answers-required": "Ten minste één correct antwoord is vereist",
  "safety-instruction-form.blocks.page-separator": "Pagina Scheider",
  "safety-instruction-form.blocks.page-separator-placeholder": "Voer paginatitel in",

  "menu.checklists": "Checklists",

  "checklists.title": "Checklists",
  "checklists.create": "Nieuwe Checklist",
  "checklists.status": "Status",
  "checklists.organisation": "Organisatie",
  "checklists.created-by": "Aangemaakt door",
  "checklists.created-at": "Aangemaakt op",
  "checklists.status.concept": "Concept",
  "checklists.status.published": "Gepubliceerd",

  "checklists.create-modal.header": "Checklist aanmaken",
  "checklists.create-modal.title": "Titel",
  "checklists.create-modal.title.required": "Titel is verplicht",
  "checklists.create-modal.organisation": "Organisatie",
  "checklists.create-modal.organisation.required": "Organisatie is verplicht",
  "checklists.create-modal.create": "Aanmaken",
  "checklists.create-modal.error.create-failed": "Checklist aanmaken mislukt",

  "create-checklist-modal.error.create-failed": "Checklist aanmaken mislukt",

  "checklists.edit.placeholder": "Checklist inhoudseditor zal hier worden geïmplementeerd. Je kunt de titel, beschrijving en checklist items bewerken.",
  "checklists.edit.notFound": "Checklist niet gevonden",

  "checklists.delete-title": "Checklist verwijderen",
  "checklists.delete-message": "Weet je zeker dat je deze checklist wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
  "checklists.delete-confirm": "Verwijderen",
  "checklists.delete-success": "Checklist succesvol verwijderd",
  "checklists.delete-error": "Kon checklist niet verwijderen",

  "checklists.publish": "Publiceren",
  "checklists.publish-title": "Checklist publiceren",
  "checklists.publish-message": "Weet je zeker dat je deze checklist wilt publiceren? Eenmaal gepubliceerd kunnen de checklist items niet meer worden bewerkt en kan de status niet terug worden gewijzigd.",
  "checklists.publish-confirm": "Publiceren",
  "checklists.publish-success": "Checklist succesvol gepubliceerd",
  "checklists.publish-error": "Kon checklist niet publiceren",
  "checklists.publish-error-new-checklist": "Dit is een nieuwe checklist. Sla het eerst op voordat je publiceert.",
  "checklists.publish-error-unsaved-changes": "Sla je wijzigingen op voordat je publiceert.",
  "checklists.publish-error-not-concept": "Alleen checklists in de status Concept kunnen worden gepubliceerd.",

  "checklists.item.delete-title": "Item verwijderen",
  "checklists.item.delete-message": "Weet je zeker dat je dit checklist item wilt verwijderen?",
  "checklists.item.delete-confirm": "Verwijderen",

  "checklists.save-success": "Checklist succesvol opgeslagen",
  "checklists.save-error": "Kon checklist niet opslaan",

  "checklists.error.id-not-found": "Checklist ID niet gevonden",
  "checklists.error.load-failed": "Kon checklist niet laden",

  "checklist-form.title": "Titel",
  "checklist-form.title.required": "Titel is verplicht",
  "checklist-form.title.maxlength": "Titel mag niet langer zijn dan 200 karakters",
  "checklist-form.status": "Status",
  "checklist-form.description": "Beschrijving",
  "checklist-form.items": "Checklist Items",
  "checklist-form.item.placeholder": "Voer checklist item in...",
  "checklist-form.item.required": "Item tekst is verplicht",
  "checklist-form.item.maxlength": "Item tekst mag niet langer zijn dan 500 karakters",
  "checklist-form.item.move-up": "Item omhoog verplaatsen",
  "checklist-form.item.move-down": "Item omlaag verplaatsen",
  "checklist-form.item.remove": "Item verwijderen",
  "checklist-form.add-item": "Item toevoegen",
  "checklist-form.save-validation": "Herstel de formulierfouten voordat je opslaat",

  "thesaurus.title": "Platformthesaurus beheren",
  "thesaurus.add-node": "+ Knooppunt toevoegen",
  "thesaurus.error": "Kan thesaurusgegevens niet laden",
  "thesaurus.edit-function": "Functie Bewerken",
  "thesaurus.add-function": "Functie Toevoegen",
  "thesaurus.function-name": "Functienaam",
  "thesaurus.function-name-placeholder": "Voer functienaam in",
  "thesaurus.function-description": "Beschrijving",
  "thesaurus.function-description-placeholder": "Voer functiebeschrijving in",
  "thesaurus.synonyms": "Synoniemen",
  "thesaurus.synonyms-placeholder": "Synoniemen toevoegen",
  "thesaurus.non-selectable": "Niet-selecteerbaar",
  "thesaurus.non-selectable-label": "Deze node kan niet als functie geselecteerd worden",
  "thesaurus.management-organisation": "Beheerorganisatie",
  "thesaurus.select-organisation": "Selecteer organisatie",
  "thesaurus.load-organisations-error": "Fout bij het laden van organisaties",
  "thesaurus.save-edit-success": "Functie bijgewerkt",
  "thesaurus.save-new-success": "Functie aangemaakt",
  "thesaurus.save-error": "Opslaan van functie mislukt",
  "thesaurus.delete-title": "Functie verwijderen",
  "thesaurus.delete-message": "Weet je zeker dat je deze functie wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
  "thesaurus.delete-confirm": "Verwijderen",
  "thesaurus.delete-success": "Functie succesvol verwijderd",
  "thesaurus.delete-error": "Verwijderen van functie mislukt",
  "thesaurus.cannot-delete-parent-function": "Kan een functie met kinderen niet verwijderen. Verwijder of verplaats eerst de kinderen.",

  "safety-requirements.title": "Veiligheidseisen",
  "safety-requirements.create": "Nieuwe Veiligheidseis",
  "safety-requirements.create-success": "Veiligheidseis succesvol aangemaakt",
  "safety-requirements.create-error": "Aanmaken van veiligheidseis mislukt",
  "safety-requirements.update-success": "Veiligheidseis succesvol bijgewerkt",
  "safety-requirements.update-error": "Bijwerken van veiligheidseis mislukt",
  "safety-requirements.delete-success": "Veiligheidseis succesvol verwijderd",
  "safety-requirements.delete-error": "Verwijderen van veiligheidseis mislukt",
  "safety-requirements.enable-requirement": "Eis inschakelen",
  "safety-requirements.disable-requirement": "Eis uitschakelen",
  "safety-requirements.enable-success": "Organisatie-eis succesvol ingeschakeld",
  "safety-requirements.enable-error": "Inschakelen van organisatie-eis mislukt",
  "safety-requirements.disable-success": "Organisatie-eis succesvol uitgeschakeld",
  "safety-requirements.disable-error": "Uitschakelen van organisatie-eis mislukt",
  "safety-requirements.type.Certificates": "Certificaten",
  "safety-requirements.type.Checklists": "Checklists",
  "safety-requirements.type.SafetyInstructions": "Veiligheidsinstructies",
  "safety-requirements.edit.title": "Veiligheidseis bewerken",
  "safety-requirements.form.title": "Titel",
  "safety-requirements.form.title.placeholder": "Titel van de veiligheidseis",
  "safety-requirements.form.type": "Type veiligheidseis",
  "safety-requirements.form.target-audience": "Doelgroep",
  "safety-requirements.form.exclude": "Uitsluiten",
  "safety-requirements.form.grace": "Uitsteltype",
  "safety-requirements.target-audience.include-organisation": "Iedereen van organisatie meenemen",
  "safety-requirements.target-audience.exclude-organisation": "Iedereen van organisatie uitsluiten",
  "safety-requirements.target-audience.include-function": "Iedereen met functie meenemen",
  "safety-requirements.target-audience.exclude-function": "Iedereen met functie uitsluiten",
  "safety-requirements.target-audience.include-management": "Alleen leidinggevenden meenemen",
  "safety-requirements.target-audience.exclude-management": "Leidinggevenden uitsluiten",
  "safety-requirements.target-audience.include-everyone": "Iedereen meenemen",
  "safety-requirements.target-audience.exclude-everyone": "Iedereen uitsluiten",
  "safety-requirements.target-audience.everyone": "Iedereen",
  "safety-requirements.target-audience.management": "Leidinggevenden",
  "safety-requirements.target-audience.organisation.placeholder": "Organisatie",
  "safety-requirements.target-audience.function.placeholder": "Functie",
  "safety-requirements.add": "Veiligheidseis toevoegen",
  "safety-requirements.page-title": "Veiligheidseisen voor",
  "safety-requirements.include": "Meenemen:",
  "safety-requirements.exclude": "Uitsluiten:",
  "safety-requirements.none": "Geen",
  "safety-requirements.grace-type.title": "Uitsteltype:",
  "safety-requirements.grace-type.None": "Geen",
  "safety-requirements.grace-type.Warning": "Waarschuwing",

  "organisation-safety-requirement.delete-title": "Veiligheidseis verwijderen",
  "organisation-safety-requirement.delete-message": "Weet je zeker dat je deze veiligheidseis wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
  "organisation-safety-requirement.delete-confirm": "Verwijderen",

  "project-safety-requirement.delete-title": "Veiligheidseis verwijderen",
  "project-safety-requirement.delete-message": "Weet je zeker dat je deze veiligheidseis wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
  "project-safety-requirement.delete-confirm": "Verwijderen",

  "safety-requirements.show-inherited-options": "Toon opties geërfd van",

  "field.visible-in-app": "Veld is zichtbaar in de app",

  "function-selector.title": "Selecteer functie",
  "function-selector.search.placeholder": "Zoek functies...",
  "function-selector.search.clear": "Wissen",
  "function-selector.search.no-results": "Geen resultaten gevonden",
  "function-selector.category": "Categorie",
  "function-selector.root": "Alle functies",
  "function-selector.select-this-category": "Selecteer deze categorie",
  "function-selector.cancel": "Annuleren",

  "": ""
}
